import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { OrderProperty } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseContractPropertyService extends TmsWebBaseEditCreateService<OrderProperty, OrderProperty> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseContractProperty', $localize`Purchase Contract Property`);
  }
}
